import React, { createContext, useState, useEffect } from 'react';

// Create the context
export const CurrencyContext = createContext();

// Create a provider component
export const CurrencyProvider = ({ children, isLoggedIn, userCurrency }) => {
  const defaultCurrency = {
    id: 4,
    currency: 'INR',
    value: 1, // Default currency value for INR
    icon: '₹',
    code: 'IN'
  };

  // Use local storage for non-logged-in users
  const getInitialCurrency = () => {
    if (isLoggedIn && userCurrency) {
      // If the user is logged in, use the backend's currency preference
      return userCurrency;
    }
    const savedCurrency = localStorage.getItem('selectedCurrency');
    return savedCurrency ? JSON.parse(savedCurrency) : defaultCurrency;
  };

  const [currencyContxt, setCurrencyContxt] = useState(getInitialCurrency());

  const updateCurrencyContxt = (newCurrency) => {
    setCurrencyContxt(newCurrency);
    if (!isLoggedIn) {
      // Only update localStorage for non-logged-in users
      localStorage.setItem('selectedCurrency', JSON.stringify(newCurrency));
    }
    // For logged-in users, you can make an API call to persist the preference in the backend.
  };

  useEffect(() => {
    // On logout or login, reset the currency if the user is not logged in
    if (!isLoggedIn) {
      setCurrencyContxt(defaultCurrency);
      localStorage.removeItem('selectedCurrency'); // Clear localStorage when the user logs out
    }
  }, [isLoggedIn]);

  return (
    <CurrencyContext.Provider value={{ currencyContxt, updateCurrencyContxt }}>
      {children}
    </CurrencyContext.Provider>
  );
};
